export default "__VITE_ASSET__7iaxwI1x__"